import React from "react";
import HyperLogo from "../Images/HyperLogo.png";
import styled from "styled-components";

const Main = styled.div`
  height: 35px;
  background-color: #202731;
  z-index: 1000;
  position: -webkit-sticky;
  position: sticky;
  box-shadow: 0px 4px 12px -20px rgb(0 0 0 / 20%),
    0px 8px 20px 2px rgb(0 0 0 / 14%), 0 9px 46px 8px rgb(0 0 0 / 12%);
  display: flex;
  align-items: center;
  border-bottom: 1px solid #030304;
`;

const Logo = styled.img`
  margin-left: auto;
  margin-right: auto;
  height: 50%;
`;
export default function Header() {
  return (
    <Main>
      <Logo src={HyperLogo} alt="Hyper Logo" />
    </Main>
  );
}
